import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { getCookie, handleSetCookie } from "@/utils/cookieutils";

const useGeoLocation = () => {
  const [geoLocationData, setGeoLocationData] = useState({});
  const [ipAddress, setIPAddress] = useState("");
  const [cookiesChecked, setCookiesChecked] = useState(false);

  const fetchIpDetails = useCallback(async () => {
    try {
      const response = await fetch(`/api/getCountriesUrls?ip=${ipAddress}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: window.location.origin,
        },
      });
      let countryCode, countryName, city;

      if (response.ok) {
        const dataFromIpBase = await response.json();
        countryCode = dataFromIpBase?.data?.location?.country?.alpha2;
        countryName = dataFromIpBase?.data?.location?.country?.name;
        city = dataFromIpBase?.data?.location?.city?.name;
      }

      if (!countryCode && !countryName && !city) {
        const fallbackData = await fetchCountryData();
        countryCode = fallbackData?.country;
        countryName = fallbackData?.country;
        city = fallbackData?.city;
      }

      const removeAccents = (str: string) =>
        str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      const cityText = city ? removeAccents(city.trim()) : "";

      const finalCountryCode = countryCode || "ZA";
      const finalCountryName = countryName || "South Africa";
      const finalCity = cityText || "";

      setGeoLocationData({
        countryCode: finalCountryCode,
        countryName: finalCountryName,
        city: finalCity,
      });

      handleSetCookie("countryCode", finalCountryCode);
      handleSetCookie("countryName", finalCountryName);
      handleSetCookie("city", finalCity);
    } catch (error) {
      console.error("Error fetching country details:", error);
    }
  }, [ipAddress]);

  useEffect(() => {
    const cookieCountryCode = getCookie("countryCode");
    const cookieCountryName = getCookie("countryName");
    const cookieCity = getCookie("city");

    const removeAccents = (str: string) =>
      str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const cityText = cookieCity ? removeAccents(cookieCity.trim()) : "";

    if (cookieCountryCode && cookieCountryName && cookieCity) {
      setGeoLocationData({
        countryCode: cookieCountryCode,
        countryName: cookieCountryName,
        city: cityText,
      });
      setCookiesChecked(true);
    } else {
      axios
        .get("https://api.ipify.org?format=json")
        .then((res) => {
          setIPAddress(res?.data?.ip);
        })
        .catch((error) => console.error("Error fetching IP address:", error));
    }
  }, []);

  useEffect(() => {
    if (ipAddress && !cookiesChecked) {
      fetchIpDetails().then(() => setCookiesChecked(true));
    }
  }, [ipAddress, cookiesChecked, fetchIpDetails]);

  const fetchCountryData = async () => {
    try {
      const response = await axios.get(`https://ipinfo.io/json`);
      return response.data;
    } catch (error) {
      console.error("Error fetching IP details from fallback API:", error);
      return null;
    }
  };

  return geoLocationData;
};

export default useGeoLocation;
